import { useBaseComponent } from 'basics/component/base-component';
import HoverIcon from 'components/HoverIcon';
import { ReactElement } from 'react';
import { smartDateString } from 'utils/date';
import messages from '../../Messages';
import {
  FileInfomationAttachment,
  FileInfomationAttachmentItem,
  FileNameAttachment,
  TaskAttachmentBox,
  TaskAttachmentContainer,
  TaskAttachmentContent,
  TaskAttachmentRemoveIconHolder,
  TaskContentAttachment,
  TaskIconAttachments,
} from './Task-AttachmentsItem-style';
import { ITaskAttachmentsItemProps } from './TaskAttachmentsItem-type';
import LocalIcon from 'ui/LocalIcon';
import { checkFileFormat } from 'utils/check-file-type/checkFileFormat';
import { summerizeText } from 'utils/summerizeText';

export const TaskAttachmentsItem = (
  props: ITaskAttachmentsItemProps
): ReactElement => {
  useBaseComponent<ITaskAttachmentsItemProps>({ props });

  const { attachment, users, editable, onDeleteAttachment, onSelect } = props;
  const { id, document, senderId } = attachment;
  const { properties, uploadDate } = document;

  return (
    <TaskAttachmentBox key={id}>
      <TaskAttachmentContent
        onClick={(): void => {
          onSelect();
        }}
      >
        <TaskAttachmentContainer>
          <TaskIconAttachments>
            <LocalIcon iconName={checkFileFormat(document.properties.format)} />
          </TaskIconAttachments>
          <TaskContentAttachment editable={editable || false}>
            <FileNameAttachment>
              {summerizeText(properties.displayName, 24)}
            </FileNameAttachment>
            <FileInfomationAttachment>
              <FileInfomationAttachmentItem>
                {summerizeText(messages.byUser(users[senderId]?.name), 20)}
              </FileInfomationAttachmentItem>
              <FileInfomationAttachmentItem type={'date'}>
                {smartDateString(new Date(uploadDate || 0), true)}
              </FileInfomationAttachmentItem>
            </FileInfomationAttachment>
          </TaskContentAttachment>
          {editable && (
            <TaskAttachmentRemoveIconHolder>
              <HoverIcon
                color="red"
                type="trash"
                onClick={(event: any) => {
                  const confirmed: boolean = confirm(
                    messages.confirmDeleteAttachment(properties.displayName)
                  );

                  if (confirmed) {
                    event.stopPropagation();
                    onDeleteAttachment(id);
                  }
                }}
              />
            </TaskAttachmentRemoveIconHolder>
          )}
        </TaskAttachmentContainer>
      </TaskAttachmentContent>
    </TaskAttachmentBox>
  );
};
